import React from "react";
import { Tab as CusTab } from "material-ui/Tabs";

class Tab extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        if (this.props.isWidgetComp) {
            return (
                <div
                    value={this.props.value}
                    className={this.props.className}
                    style={Object.assign({}, this.props.style, { lineHeight: "normal" })}
                >
                    {this.props.label}
                </div>
            );
        }
        return (
            <CusTab
                {...this.props}
                style={Object.assign({ backgroundColor: "#ffffff" }, this.props.style || {})}
                buttonStyle={Object.assign(
                    {
                        maxHeight: 28,
                        margin: "10px 0px",
                        backgroundColor: "#ffffff",
                        fontSize: "12px",
                        color: this.props.selected ? "#16325c" : "#54698d",
                        borderLeft: "solid 1px #e8edf4",
                        textTransform: "capitalize",
                        fontWeight: this.props.selected ? 500 : 400
                        // fontFamily: this.props.selected ? "Roboto-Medium" : "Roboto-Regular"
                    },
                    this.props.buttonStyle
                )}
            />
        );
    }
}

Tab.muiName = "Tab";
export default Tab;
